import { useQuery } from "@tanstack/react-query";
import { Radio, ShieldAlert } from "lucide-react";

import { orpc } from "@/client";
import { cn } from "@/lib/utils";
import { SystemLabels } from "@/lib/labels/system";

export function SendKeySection() {
	const { data } = useQuery(orpc.send.config.queryOptions());

	const enabled = data?.enabled ?? false;

	return (
		<section
			data-component="system-send-key"
			data-enabled={enabled}
			className={cn(
				"flex items-start gap-3 rounded-lg border p-4 md:p-5",
				enabled ? "border-info/40 bg-info/10" : "border-destructive/50 bg-destructive/10",
			)}
		>
			{enabled && <Radio className="mt-0.5 size-5 shrink-0 text-info" />}
			{!enabled && <ShieldAlert className="mt-0.5 size-5 shrink-0 text-destructive" />}

			<div className="min-w-0">
				<p
					className={cn(
						"font-display text-base font-semibold",
						enabled ? "text-info" : "text-destructive",
					)}
				>
					{enabled && SystemLabels.sendKeyOn}
					{!enabled && SystemLabels.sendKeyOff}
				</p>

				<p className="mt-0.5 text-sm text-muted-foreground">
					{enabled && SystemLabels.sendKeyOnDetail}
					{!enabled && SystemLabels.sendKeyOffDetail}
				</p>
			</div>
		</section>
	);
}
